import { ACTIONS, TRIGGERS } from "@/constants/flows";
import { Action } from "@/models/flows";

export const getActionBasedOnType = (type: string): Action | undefined => {
  const allActions = [...TRIGGERS, ...Object.values(ACTIONS).flat()];
  return allActions.find((action) => action.type === type);
};
